<template>
  <div v-if="info" v-opacity class="gradesearch" :style="{backgroundImage: 'url(' +backgroundImage+ ')'}">
    <div class="base">
      <van-nav-bar class="isccc" title="成绩查询"/>
      <div class="container pl-24 pr-24">
        <div class="gc-logo font-18">
          <img v-if="info.collegeLogoUrl" class="gl-img" :src="info.collegeLogoUrl" alt="">
          {{ info.resultPageName }}
        </div>
        <div class="gc-form">
          <div class="gcf-top font-18 fb">
            成绩查询
          </div>
          <div class="gcf-content">
            <div v-for="item in showKeys" :key="item" class="lc-input pl-16 pr-16 mt-16">
              <div class="lc-label is-required mb-8">
                {{ form[item].value }}
              </div>
              <van-field v-model="form[item].content" :placeholder="form[item].placeholder" clearable/>
            </div>
            <div class="gcf-content">
              <div class="lc-input pl-16 pr-16 mt-16">
                <div class="lc-label is-required mb-8">
                  验证码
                </div>
                <div style="display: flex; align-items: center; justify-content: space-between;">
                  <van-field v-model="form.code" placeholder="请输入验证码" clearable/>
                  <Identify :identifyCode="identifyCode"></Identify>
                  <van-icon style="cursor: pointer;" @click="refreshCode" name="replay"/>
                </div>
              </div>
            </div>
          </div>
          <div class="gcf-btn">
            <van-button @click="onsubmit" round block size="large" color="linear-gradient(137deg, #00A7FF 0%, #0076FF 100%)">
              查询
            </van-button>
          </div>
        </div>
        <div class="gc-foot font-14">{{ info.resultPageName }} <a class="font-14" href="http://beian.miit.gov.cn" style="color: #fff;margin-left: 10px;" target="_blank">粤ICP备15113647号</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Button, Field, NavBar, Toast, Icon} from 'vant'
import ApiInfo from '@/apis/api-info.js'
import * as _localStorage from '@/utils/storage'
import Identify from "./components/code.vue";

export default {
  components: {
    Identify,
    [NavBar.name]: NavBar,
    [Button.name]: Button,
    [Field.name]: Field,
    [Icon.name]: Icon,
  },
  data() {
    return {
      identifyCodes: "1234567890abcdefjhijklinopqrsduvwxyz",
      identifyCode: "",
      info: '',
      backgroundImage: require('../../static/bg_ty_sj.png'),
      showKeys: [],
      formArr: [
        'validationField',
        'examineeName',
        'examineeIdNo',
        'userAccount',
      ],
      form: {
        code: '',
        validationField: {
          code: '',
          content: '',
          value: '',
          placeholder: '请输入',
        },
        examineeName: {
          content: '',
          value: '姓名',
          placeholder: '请输入姓名',
        },
        examineeIdNo: {
          content: '',
          value: '证件号',
          placeholder: '请输入身份证/护照/港澳通行证/台胞证',
        },
        userAccount: {
          content: '',
          value: '小艺帮账号',
          placeholder: '请输入小艺帮账号',
        },
      },
    }
  },
  mounted() {
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
  },
  async created() {
    const collegeId =
        this.$route.query.collegeId || _localStorage.getStorageSync('collegeId')
    if (collegeId) {
      _localStorage.setStorageSync('collegeId', collegeId)
      await this.getInfo()
      this.info = _localStorage.getStorageSync('info') || {}
      this.changeTitle()
      this.changeIcon()
      this.form.validationField.value = this.info.customField || ''
      this.form.validationField.palcdholder =
          '请输入' + (this.info.customField || '')
      const showKeys = this.info.validationField.split(',') || []
      if (showKeys && showKeys.length) {
        showKeys.sort()
        this.showKeys = showKeys.map((v) => this.formArr[Number(v)])
      }
    }
  },
  methods: {
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
      }
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    onBack() {
    },
    async onsubmit() {
      let pass = true
      for (let index = 0; index < this.showKeys.length; index++) {
        const key = this.showKeys[index]
        if (!this.form[key].content) {
          Toast(`${this.form[key].placeholder}`)
          pass = false
          break
        }
      }
      if (!pass) return
      if (!this.form.code) {
        Toast(`请输入验证码！`)
        return
      }
      if (this.form.code.toLowerCase() !== this.identifyCode.toLowerCase()) {
        this.refreshCode();
        return Toast("验证码不正确，请重新输入！")
      }
      const collegeId = _localStorage.getStorageSync('collegeId')
      const param = {
        collegeId: collegeId,
      }
      this.showKeys.forEach((v) => {
        param[v] = this.form[v].content
      })
      const res = await ApiInfo.POSTresultList(param)
      _localStorage.setStorageSync('resultList', res.data || [])
      _localStorage.setStorageSync('login', this.form)
      this.$router.push('/list?collegeId=' + collegeId)
    },
    async getInfo() {
      const collegeId = _localStorage.getStorageSync('collegeId')
      const res = await ApiInfo.GETresultPageBycollegeId({collegeId})
      if (res.data) {
        _localStorage.setStorageSync('info', res.data)
        if (res.data.mobileWallpaperUrl) {
          this.backgroundImage = res.data.mobileWallpaperUrl
        }
      } else {
        Toast('请检查链接是否正确！')
      }
    },
    changeTitle() {
      window.document.title = `${
          this.info.resultPageName ? this.info.resultPageName : '成绩查询'
      }`
    },
    async changeIcon() {
      if (this.info.collegeLogoUrl) {
        let link =
            document.querySelector("link[rel*='icon']") ||
            document.createElement('link')
        link.type = 'image/x-icon'
        link.rel = 'shortcut icon'
        link.href = this.info.collegeLogoUrl
        document.getElementsByTagName('head')[0].appendChild(link)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.gradesearch {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  // background-image: url('../../static/bg_ty_sj.png');
  background-size: cover;
  background-color: rgba(0, 0, 0, 0.3);
  background-repeat: no-repeat;
  background-position: center;
  overflow: hidden;
}

.base {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  z-index: 1;
}

.container {
  width: 100%;
  // flex: 1;
  max-height: calc(100vh - 46px);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  .gc-logo {
    color: #fff;
    height: 65px;
    display: flex;
    justify-content: center;
    align-items: center;

    .gl-img {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
  }

  .gc-form {
    max-height: calc(100% - 65px - 45px);
    width: 100%;
    background: #fff;
    // background: rgba(255, 255, 255, 0.39);
    box-shadow: 0px 8px 16px rgba(39, 3, 27, 0.24);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
  }

  .gc-foot {
    color: #fff;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.lc-label {
  margin-right: 4px;
  word-break: keep-all;
  display: flex;
  align-items: flex-start;
}

.is-required::before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
  margin-top: 5px;
}

.lc-input /deep/ .van-cell {
  padding: 8px;
  border: 1px solid #a2a6b8;
  border-radius: 4px;

  ::after {
    content: '';
  }
}

.gcf-top {
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 2px 4px rgba(39, 3, 27, 0.1);
}

.gcf-content {
  max-height: calc(100% - 50px - 80px);
  overflow: auto;
}

.gcf-btn {
  height: 80px;
  padding: 0 16px;
  margin-top: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 4px rgba(39, 3, 27, 0.1);
}

.isccc /deep/ .van-icon {
  color: #323233;
}

</style>
